module.exports = __webpack_public_path__ + "img/6.ca203f07.jpg";